<script lang="ts">
	import LoginSection from "./login/LoginSection.svelte";
	import { Nav, NavItem, NavLink } from "@sveltestrap/sveltestrap";
	import { loginStatus } from "../store/loginV2.js";
	import { LoginStatus } from "../../common/types";
	import { _ } from "svelte-i18n";
</script>

<Nav navbar class="p-2">
	<NavItem>
		<NavLink href="/#/">{$_("landingpage.menu.home")}</NavLink>
	</NavItem>
	<NavItem>
		<NavLink href="/#/add-suggestion">{$_("landingpage.menu.suggestTopic")}</NavLink>
	</NavItem>
	{#if $loginStatus.status === LoginStatus.LOGGED_IN}
		<NavItem>
			<NavLink href="/#/list-suggestions">{$_("landingpage.menu.reviewSuggestions")}</NavLink>
		</NavItem>
		<NavItem>
			<NavLink href="/#/new-presentation">{$_("landingpage.menu.newPresentation")}</NavLink>
		</NavItem>
		<NavItem>
			<NavLink href="/#/story/new">{$_("landingpage.menu.newStory")}</NavLink>
		</NavItem>
		<NavItem>
			<NavLink href="/#/dark-tales/new">{$_("landingpage.menu.newDarkTale")}</NavLink>
		</NavItem>
		<NavItem>
			<NavLink href="/#/xmas/new">{$_("landingpage.menu.newChristmasTale")}</NavLink>
		</NavItem>
	{/if}
</Nav>
<Nav class="ms-auto p-2" navbar>
	<LoginSection />
</Nav>
